import React from 'react'

import {colors} from "../../utils/styles"

const progressBarWrapper = {
  display: 'flex',
  justifyContent: 'center'
}

const progressBar = {
  fontSize: 14,
  fontWeight: 400,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  border: 'solid 1px #EEEEEE',
  borderRadius: 8,
  minHeight: 96,
  minWidth: 870,
  boxShadow: '0 9px 28px 8px rgba(0, 0, 0, 0.05), '
      + '0 3px 6px -4px rgba(0, 0, 0, 0.12), '
      + '0 6px 16px 0 rgba(0, 0, 0, 0.08)'
}

const circleStepsWrapper = {
  fontSize: 16,
  display: 'flex',
  flexDirection: ' row',
  marginBottom: 10,
}

const greyCircle = {
  boxSizing: 'border-box',
  width: 32,
  height: 32,
  backgroundColor: '#f0f0f0',
  borderRadius: '50%',
  lineHeight: '32px',
  textAlign: 'center',
  color: '#545454'
}

const checkCircle = {
  boxSizing: 'border-box',
  width: 32,
  height: 32,
  background: colors.mocControlItemBgActive,
  borderRadius: '50%',
  lineHeight: '32px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}

const redCircle = {
  backgroundColor: '#CC3333',
  color: '#FFF',
  boxSizing: 'border-box',
  width: 32,
  height: 32,
  borderRadius: '50%',
  textAlign: 'center',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}

export class DigitalProgressBar extends React.Component {

  getCircle(index, position) {
    if (index > position) {
      return <div style={greyCircle}>{index + 1}</div>
    }
    if (index < position) {
      return <div style={checkCircle}>
              <img alt="progress check icon" src="images/progress-check-icon.svg" />
             </div>
    }
    return <div style={redCircle}>
      {index + 1}
    </div>
  }

  render() {
    const {steps, position} = this.props
    return (
        <div style={progressBarWrapper}>
        <div style={progressBar}>
          <div style={circleStepsWrapper}>
            {steps.map((each, index) => {
              const showLine = index < (steps.length - 1)
              return (
                  <React.Fragment key={index}>
                    <div>
                      {this.getCircle(index, position)}
                    </div>
                    {showLine && <div style={{
                      width: 180,
                      height: 16,
                      borderBottom: 'solid 1px ' + colors.mocTextTertiary,
                    }}/>}
                  </React.Fragment>
              )
            })}
          </div>
          <div style={{display: 'flex', flexDirection: 'row'}}>
            {steps.map((each, index) => {
              let fontColor = index === position
                  ? colors.mocText
                  : (index < position) ? colors.grayDark : colors.grayMiddle
              return (<div key={index}
                           style={{
                             width: steps[index].size,
                             textAlign: 'center',
                             color: fontColor
                           }}>{steps[index].label}</div>)
            })}
          </div>
        </div>
        </div>
    )
  }
}